import React from 'react';

const SpeakerList = ({ speakers }) => {
  return (
    <div className="flex flex-col gap-3 mt-7">
      {speakers.map((speaker, index) => (
        <p key={index} className="text-[17px] leading-[1.85] text-black">
          <span className="text-gray-400 mr-2">→</span>
          <strong>{speaker.name},</strong> {speaker.role}
        </p>
      ))}
    </div>
  );
};

export default SpeakerList;
